/**
 * Shared utilities for schedule and stats filters.
 * - calculateSelectWidth : dynamic select sizing
 * - initFilterGlobals    : sets up all shared window-level state
 */

export function calculateSelectWidth($select) {
    const temp = $('<span>').css({
        visibility: 'hidden',
        position  : 'absolute',
        whiteSpace: 'nowrap',
        font      : $select.css('font'),
    }).text($select.find(':selected').text());

    $('body').append(temp);
    const width = temp[0].offsetWidth + 60;
    temp.remove();
    return width;
}

export function initFilterGlobals() {
    window.oTheParams = { season: 0, tournament_id: 0, team_id: 0, date_from: 0, date_to: 0 };

    window.bTheInitial              = true;
    window.sTheStatsQueryType       = '';
    window.sTheStatsQueryId         = 0;
    window.iTheStatsQueryTournament = 0;
    window.iTheStatsQueryFrom       = 0;
    window.iTheStatsQueryTo         = 0;
}




// WEBPACK FOOTER //
// ./scripts/routes/common/prime-filter-utils.js